import { error } from "console";
import React from "react";

interface InputProps {
  lable: string;
  placeholder?: string;
  value?: string;
  type?: string;
  onChange?: any;
  name?: string;
  error?: string;
}

const Input = (props: InputProps) => {
  const { lable, placeholder, value, type, onChange, name, error } = props;
  return (
    <div className="my-1">
      <div className="text-sky-900  mb-1 text-sm">{lable}</div>
      <input
        required
        type={type}
        className="w-[300px] h-8 outline-none border pl-2 text-sm"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
      />
      <div className="text-[red] text-sm">{error}</div>
    </div>
  );
};

export default Input;
